import home from './src/home.vue'

import Wifi from './src/wifi.vue' //Wifi分析
import TouristPortrait from './src/touristPortrait.vue' //游客画像
import Ticket from './src/ticket.vue' //门票收入统计
import BizVehicle from './src/bizVehicle.vue' //停车场统计

let views = {
    home,
    Wifi,
    TouristPortrait,
    Ticket,
    BizVehicle
};

export default views;